const THREE = require('three') 
import { DEG_TO_RAD, clamp  } from '@/helpers/MathUtils'
import TweenMax from 'gsap'
 
class DoorIrisFbo {

  constructor(config) {

    this.USE_FBO = true;

    this.count = 0; 
    this.renderer = config.renderer;
    this.container = config.container; 

    this.setup();
    this.resize() 
  } 

  setup() {

    let width = 1024 ;
    let height =1024 ;

    this.fbo = new THREE.WebGLRenderTarget(width, height, { 
      minFilter: THREE.LinearFilter, 
      magFilter: THREE.LinearFilter, 
      format: THREE.RGBAFormat
    }); 
 
    this.scene = new THREE.Scene();  
    this.camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, -100, 1000 );
    this.camera.position.z = 1;
    this.scene.add( this.camera );

    this.createPieces();
 
      this.renderer.render(this.scene, this.camera, this.fbo);
  }

  createPieces() {
    this.pieces = new THREE.Group();

    let len = 8;
    let texture = this.createTexture(require('@/assets/img/doors/door-blade4.png'));  
    for (var i = 0; i < len; i++) {
      let piece = new THREE.Mesh(
        new THREE.PlaneBufferGeometry(1024 * 0.8, 1024 * 0.8), 
        new THREE.MeshBasicMaterial({ 
          map: texture, 
          transparent: true
        })
      ); 

      let piecewrap = new THREE.Group();
      piecewrap.rotation.z = (i * (360 / len)) * DEG_TO_RAD;
      piecewrap.position.z = -(i * 0.1 ); 
  
      piece.position.y = 410; 
      piece.position.x = 20; 
      piece.rotation.y = (6 * DEG_TO_RAD);
      piecewrap.add(piece); 
      this.pieces.add(piecewrap);

      // if(i === (len - 1)){
      //   piece.material.color = new THREE.Color(0xff1f6d)
      // }
    }

    if(this.USE_FBO){ 
      this.scene.add(this.pieces);
    } else {
      this.container.add(this.pieces);
    }
  }

  getTexture(){
    return this.fbo;
  }

  tick(){ 
 
   // if(this.USE_FBO ){
    // this.renderer.render(this.scene, this.camera, this.fbo);
    //}

    this.count += 0.01;
    this.container.rotation.z = this.count;
    // let pieces = this.pieces.children;
    // for (var i = 0; i < pieces.length; i++) {
    //   let piece = pieces[i].children[0];
    //   // piece.position.y = clamp(Math.abs(Math.cos(this.count)) * 100, 62, 100);  
    // }
  }

  resize() {

    if(this.USE_FBO){
      let width = 1024;
      let height = 1024;
      this.fbo.setSize(width , height  );  
      this.camera.left = width / -2;
      this.camera.right = width / 2;
      this.camera.top = height / 2;
      this.camera.bottom = height / -2; 
      this.camera.updateProjectionMatrix(); 
    } 
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img);   
    texture.needsUpdate = true;
    return texture;
  }

  updateRoute(val) { 
    switch(val.name) { 
        case 'question':
            let pieces = this.pieces.children;
            for (var i = 0; i < pieces.length; i++) {
              let piece = pieces[i].children[0];
              TweenMax.to(piece.position, 4, {
                y: 900,
                ease: 'Expo.easeInOut',
                onUpdate: () => {
                  this.renderer.render(this.scene, this.camera, this.fbo);
                }
              }); 
            } 
            TweenMax.to(this.container.rotation, 4, {
              z: 180 * DEG_TO_RAD,
              ease: 'Expo.easeInOut'
            });
          break; 
      }
  }

}

export default DoorIrisFbo